import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { URLS } from 'src/app/core/enums/urls';
import { HttpMethod } from 'src/app/core/enums/http-handlers';
import { CommonService } from 'src/app/core/services/common.service';
import { AppService } from 'src/app/core/services/app.service';
// Import directly from service file to avoid pulling in LayoutModule
import { PageInfoService } from 'src/app/_metronic/layout/core/page-info.service';
import { LoadingBaseComponent } from 'src/app/core/base/loading-base.component';

@Component({
  standalone: false,
  selector: 'app-choose-org',
  templateUrl: './choose-org.component.html',
  styleUrls: ['./choose-org.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChooseOrgComponent extends LoadingBaseComponent implements OnInit, OnDestroy {
  orgs: any[] = [];
  currentUser: any;

  constructor(
    private commonService: CommonService,
    private appService: AppService,
    private pageInfoService: PageInfoService,
    cdr: ChangeDetectorRef
  ) {
    super(cdr);
  }

  ngOnInit(): void {
    this.pageInfoService.setTitle('Companies');
    this.pageInfoService.updateTitle('Companies');
    this.currentUser = this.appService.getUserDetails();
    this.appService.trailInfo = '';
    this.loadOrganizations();
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.commonService.hide();
  }

  loadOrganizations(): void {
    this.setLoading(true);
    const url = URLS.myorganization;
    this.commonService.commonApiCall(
      url,
      HttpMethod.GET,
      null,
      (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          this.orgs = res.listResult || [];
        }
        this.setLoading(false);
        this.commonService.hide();
      }
    );
  }

  switchOrganization(orgId: string): void {
    this.commonService.show();
    const url = URLS.SWITCH_ORG;
    const payload = { orgId };
    this.commonService.commonApiCall(
      url,
      HttpMethod.POST,
      payload,
      (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          this.commonService.getAppConfig(true, true, false);
        }
        this.commonService.hide();
        this.cdr.detectChanges();
      }
    );
  }

  logout(): void {
    this.commonService.logOut();
  }

  // TrackBy function for ngFor performance
  trackByOrgId(index: number, item: any): string {
    return item?.org_Id || index;
  }
}
